<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Create Supplier" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="create()" ngNativeValidate>
          <app-supplier-form [supplier]="supplier" *ngIf="supplier"></app-supplier-form>
        </form>
      </div>
    </section>
  </div>
</div>


